import React from "react";

/**
 * LogoWithXAxisCircle
 * Combines a line chart icon with a horizontal X axis, all inside a circle.
 * The circle matches the user profile (36x36px, border, rounded-full).
 */
export const LogoWithXAxisCircle: React.FC<{ color?: string; size?: number; onClick?: () => void; active?: boolean; 'data-tutorial'?: string }> = ({ color = "currentColor", size = 36, onClick, active = false, 'data-tutorial': dataTutorial }) => {
  const iconSize = size * 0.62; // scale down for more padding
  return (
    <button
      type="button"
      title="Statistics"
      onClick={onClick}
      data-tutorial={dataTutorial}
      style={{ padding: 0, background: "none", border: "none", cursor: "pointer", lineHeight: 0 }}
      aria-label="Statistics"
    >
      <span
        className="rounded-full border flex items-center justify-center overflow-hidden"
        style={{
          width: size,
          height: size,
          borderColor: color,
          color,
          display: "inline-flex",
          background: active ? "#3473DE" : "transparent",
          transition: "background 0.2s",
        }}
        aria-label="Logo with X axis"
      >
        <svg
          width={iconSize}
          height={(iconSize * 17) / 24}
          viewBox="0 0 24 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ display: "block" }}
        >
          <path d="M5.45858 8.92289L9.11598 12.479C9.60191 12.9504 10.4539 12.7511 10.7681 12.1942L14.1826 5.54399L17.5614 12.131C17.7622 12.5169 18.1445 12.7416 18.5754 12.7321C18.9771 12.7226 19.3852 12.4948 19.5472 12.0962L23.9432 1.36148C24.1279 0.912226 23.8039 0.184559 23.1787 0.0326982C22.6831 -0.0875251 22.1032 0.127611 21.9023 0.614832L18.4555 9.02097C18.3907 8.9925 18.3615 8.93871 18.3227 8.85962L15.1382 2.64281C14.9471 2.27265 14.5292 2.08915 14.1405 2.09864C13.7517 2.10813 13.3954 2.32327 13.2107 2.6871L9.5274 9.87202L6.21986 6.65131C5.81168 6.25267 5.19294 6.25584 4.74912 6.60385L0.32071 10.9351C-0.119863 11.3653 -0.0518333 12.074 0.379022 12.4505C0.842272 12.8555 1.48369 12.8112 1.93075 12.3714L5.45858 8.92606V8.92289ZM23.9659 15.6807C23.8493 15.2346 23.4832 14.9372 23.0135 14.8645H0.978332C0.479447 14.9467 0.100423 15.2789 0.0161962 15.7661C-0.0874682 16.3483 0.317471 16.8576 0.91678 17H23.0621C23.7132 16.8734 24.1246 16.285 23.9659 15.6807Z"
            fill={color}
          />
        </svg>
      </span>
    </button>
  );
};
